import React, { Component } from 'react';
import ReactPlayer from 'react-player';

import './Video.css';

import introVideo from '../assets/videos/bunker-intro-2021.mp4';

class Video extends Component {
  render() {
    return (
      <div className="Video-container">
        
        <div className="Video-content-top"></div>
        <div className="Video-content-mid">
          <div><b>The only adventure escape game in Los Angeles with an original chapter-based story and live actors that <br></br>drops you into a thrilling post-apocalyptic world.</b></div>
          <p></p>
          <ReactPlayer
            url={introVideo}
            // playing
            muted
            controls
            className="Video-player"
            width="100%"
            height="auto"
          />
        </div>
        <div className="Video-content-bottom"></div>
      </div>
    );
  }
}

export default Video;
